module.exports = {"svg":{"$":{"t":"1541066721580","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"7456","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M66.873 104.137v129.491h890.255V104.137H66.873z m0 453.22h890.255V427.866H66.873v129.491z m0 323.73h890.255V751.596H66.873v129.491z","p-id":"7457"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/navigation.svg
// module id = dXjL
// module chunks = 2